var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRecord(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "currentColor",
    focusable: "false",
    "data-icon": "menu-fold",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(.921 .75)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.063 8.127a4.063 4.063 0 1 1 4.064-4.063 4.068 4.068 0 0 1-4.064 4.063zm0-6.827a2.764 2.764 0 1 0 2.764 2.764A2.767 2.767 0 0 0 4.063 1.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.731-.65A3.381 3.381 0 1 1-.65 2.731 3.385 3.385 0 0 1 2.731-.65zm0 5.462A2.081 2.081 0 1 0 .65 2.731a2.083 2.083 0 0 0 2.081 2.081z",
    transform: "translate(7.704 2.015)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.489 7.007h11.577a.65.65 0 0 1 .65.65v1.117l2.7-.394a.65.65 0 0 1 .744.643v5.463a.65.65 0 0 1-.744.643l-2.7-.394v1.115a.65.65 0 0 1-.65.65H1.489a.65.65 0 0 1-.65-.65V7.657a.65.65 0 0 1 .65-.65zm10.927 1.3H2.139V15.2h10.277v-1.218a.65.65 0 0 1 .744-.643l2.7.394V9.774l-2.7.394a.65.65 0 0 1-.744-.643z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 5.294a.65.65 0 0 1-.65-.65V0A.65.65 0 0 1 0-.65.65.65 0 0 1 .65 0v4.644a.65.65 0 0 1-.65.65z",
    transform: "translate(13.066 9.432)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecord);
export default __webpack_public_path__ + "static/media/record.c43c591b581d8f8149ad725da64aac27.svg";
export { ForwardRef as ReactComponent };